import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useFormContext } from 'react-hook-form'
import { COUNTRY_OPTIONS } from '../constants/country'

const useStyles = makeStyles(() => ({
  asterisk: { color: '#f44336' },
  autocomplete: {
    '& .MuiFilledInput-root .MuiAutocomplete-input': {
      padding: '10px 4px 10px 6px'
    },
    '& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after': {
      display: 'none'
    }
  }
}))

function SearchableCountryField({ name, value: valueProp, onChange, disabled, required, error, helperText, label = 'Country', size = 'small' }) {
  const classes = useStyles()
  const formContext = useFormContext()
  const isControlled = valueProp !== undefined
  const currentValue = isControlled ? (valueProp || '') : (name ? (formContext?.watch(name) || '') : '')

  const selectedOption = COUNTRY_OPTIONS.find(o => o.value === currentValue) || null

  const fieldError = !isControlled && name ? formContext?.formState?.errors?.[name] : undefined

  function handleChange(_, option) {
    const newVal = option ? option.value : ''
    if (isControlled) {
      onChange && onChange({ target: { value: newVal } })
    } else if (name && formContext) {
      formContext.setValue(name, newVal, { shouldValidate: true })
    }
  }

  return (
    <Autocomplete
      className={classes.autocomplete}
      style={{ width: '100%' }}
      options={COUNTRY_OPTIONS}
      getOptionLabel={(o) => o.text || ''}
      getOptionSelected={(opt, val) => opt?.value === val?.value}
      value={selectedOption}
      onChange={handleChange}
      disabled={disabled}
      noOptionsText='No results'
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          required={required}
          helperText={fieldError?.message || helperText}
          error={!!fieldError || error}
          size={size}
          variant='filled'
          InputLabelProps={{
            ...params.InputLabelProps,
            classes: {
              root: 'ng-form-control-label',
              focused: 'ng-form-control-label-filled-focused',
              error: 'ng-form-control-label-error',
              asterisk: classes.asterisk
            }
          }}
          InputProps={{
            ...params.InputProps,
            classes: {
              root: `ng-form-control${label ? '' : ' no-label'}`,
              underline: 'ng-form-control-filled',
              focused: 'ng-form-control-filled-focused',
              error: 'ng-form-control-filled-error'
            },
            style: { backgroundColor: required ? '#FFF9C4' : '#ffffff', border: '1px solid #5f5753', borderRadius: 4 },
            disableUnderline: true
          }}
        />
      )}
    />
  )
}

export default SearchableCountryField
